/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

// https://chakra-ui.com/docs/styled-system/theming/component-style#styling-single-part-components

import type { ComponentStyleConfig } from '@chakra-ui/theme'

export const Z4Progress: ComponentStyleConfig = {
  baseStyle: {
    filledTrack: {
      bgColor: 'neutral.650',
      borderRadius: 8,
    },
    track: {
      bgColor: 'gray.150',
      borderRadius: 8,
    },
  },
  defaultProps: {
    size: 'sm',
  },
}
